module.exports = __webpack_public_path__ + "img/home1.0dcbc498.svg";